// src/components/WeeklyView.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, onSnapshot, deleteDoc, doc, orderBy } from 'firebase/firestore';

const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

const formatTime = (timeString) => {
  if (!timeString) return '';
  try {
    const [hours, minutes] = timeString.split(':');
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    return `${h}:${minutes} ${ampm}`;
  } catch (e) {
    return timeString;
  }
};

const WeeklyView = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'activities'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const activityData = [];
      querySnapshot.forEach((doc) => {
        activityData.push({ ...doc.data(), id: doc.id });
      });
      setActivities(activityData);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const deleteActivity = async (id) => {
    await deleteDoc(doc(db, 'activities', id));
  };

  if (loading) {
    return <div className="loading">Loading Schedule...</div>;
  }

  return (
    <div className="daily-view-container">
      {daysOfWeek.map((day) => (
        <div key={day} className="day-column">
          <h3>{day}</h3>
          <div className="chores-for-day">
            {activities
              .filter(activity => activity.day === day)
              .sort((a, b) => (a.time || '').localeCompare(b.time || ''))
              .map(activity => (
                <div key={activity.id} className="chore-item">
                  <div className="chore-details">
                    {activity.time && (
                      <span className="activity-time-bubble">
                        {formatTime(activity.time)}
                      </span>
                    )}
                    <span className="chore-task">{activity.name}</span>
                    
                    {/* UPDATED: Logic to choose the bubble class */}
                    {activity.assignedUserNickname && (
                      <small 
                        className={
                          activity.assignedTo === 'ALL' 
                            ? 'assigned-to-all-bubble' 
                            : 'assigned-to-bubble'
                        }
                      >
                        {activity.assignedUserNickname}
                      </small>
                    )}
                  </div>

                  <div className="chore-actions">
                    <button className="delete-btn" onClick={() => deleteActivity(activity.id)}>
                      X
                    </button>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      ))}
    </div>
  );
};

export default WeeklyView;